/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { fetchGet } from '../../utils/FetchAPIs';

const api = '/admin/currentUser';
const serverAPI = '/admin/serverConfiguration';
const tenantMailApi = '/api/tenantsmail';

export const getServerConfiguration = () => fetchGet(serverAPI);

export const getCurrentUser = tenantid => fetchGet(api, null, { tenantid });

export const getTenantsRelatedToUser = () => fetchGet(tenantMailApi);

export const getCurrentUserResources = userid =>
  fetchGet(`/api/v2/accesscontrol/user/${userid}/accessControl`, null, null);
